// extracted by mini-css-extract-plugin
export default {"modalContainer":"MoreInformationModal_modalContainer__7Fp+F","statusContent":"MoreInformationModal_statusContent__ACwLU"};